// Create a vault — web and CLI paths. Sourced from specs/cli.md §5 and
// specs/web-app.md (create is member+).

import { IconPlus, IconTerminal2, IconWorld } from "@tabler/icons-react";
import { CommandLine } from "@/components/command-line";
import { DocSection, K, P, Points } from "../doc-ui";

export function CreateVaultDoc() {
  return (
    <>
      <P>
        A vault is the unit of sharing and sync: a folder of notes that lives on your server and
        mirrors to every device that clones it. Anyone with the <K>member</K> server role or above
        can create vaults; <K>guest</K> accounts can't.
      </P>

      <DocSection
        icon={IconWorld}
        title="From the web app"
        description="Fastest when you're already here."
      >
        <P>
          Click <K>New vault</K> at the top of the sidebar, name it, and it's created with you as
          the owner. Then clone it onto a machine to start editing — see{" "}
          <em>Clone a vault to a device</em>.
        </P>
      </DocSection>

      <DocSection icon={IconTerminal2} title="From the CLI">
        <CommandLine command="cairn vault create <name>" comment="create an empty vault" />
        <P>Create and clone it into a local folder in one step:</P>
        <CommandLine
          command="cairn vault create <name> --clone [path]"
          comment="create, then clone into path (default ./<name>)"
        />
      </DocSection>

      <DocSection icon={IconPlus} title="Starting from existing notes">
        <P>
          If the notes already exist as a folder on disk, don't create-then-copy — link the folder
          instead, which turns it into a vault and keeps its content:
        </P>
        <CommandLine command="cairn vault link <path>" comment="make this folder a new vault" />
        <Points>
          <li>See <em>Link an existing folder</em> for how the first sync is previewed and backed
            up.</li>
          <li>After creating, add collaborators under <em>Share a vault &amp; manage members</em>.</li>
        </Points>
      </DocSection>
    </>
  );
}
